<template>
  <div class="absolute grid grid-rows-2 rounded right-20 z-100 w-100 bg-gray-600 text-white top-15">
    <div class="flex p-1 bg-gray-600 rounded-t h-full w-full items-center justify-around">
      <date-picker :current-date="startDate" @date-selected="setStartDate"></date-picker>
    </div>
    <div class="flex flex-row">
      <div class="flex flex-1 pl-1 pr-1 rounded-b justify-between bg-gray-800">
        <button
          class="p-0.75 text-sm focus:outline-none"
          v-for="minusStep in steps"
          :key="`-${minusStep.label}`"
          @click="stepDate(minusStep, '-')"
        >
          -{{ minusStep.label }}
        </button>
      </div>
      <div class="flex flex-1 pl-1 pr-1 rounded-b justify-between bg-gray-500 flex-row-reverse">
        <button
          class="p-0.75 text-sm focus:outline-none"
          v-for="plusStep in steps"
          :key="`+${plusStep.label}`"
          @click="stepDate(plusStep, '+')"
        >
          +{{ plusStep.label }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from '@/components/map-components/time-tool/date-picker/DatePicker.vue'
import { computed, ref, onMounted } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'TimeTool',
  components: {
    DatePicker,
  },
  setup() {
    const store = useStore()

    const startDate = computed(() => {
      return store.state.TimeTool.startDate
    })

    const hasActiveMapInstance = computed(() => {
      return store.getters['Map/hasActiveMapInstance']
    })

    const timeEnabledLayers = computed(() => {
      return store.getters['Map/timeEnabledLayers']
    })

    const allLayerTemporalEndExtents = computed(() => {
      let endExtents = ref([])
      if (timeEnabledLayers.value.length) {
        timeEnabledLayers.value.forEach((layer) => {
          Object.entries(layer.extents.temporal).filter(([key, val]) => {
            if (key === 'end' && val !== null) {
              endExtents.value.push(val)
            }
          })
        })
      }
      return endExtents.value
    })

    const maxEndDate = computed(() => {
      let maxDate = new Date()
      if (allLayerTemporalEndExtents.value.length) {
        maxDate = new Date(
          Math.max(
            ...allLayerTemporalEndExtents.value.map((val) => {
              return new Date(val)
            })
          )
        )
      }

      return maxDate
    })

    function setStartDate(date) {
      store.dispatch('TimeTool/setStartDate', date)
      updateQueries(date)
    }

    function updateQueries(date) {
      store.dispatch('Map/updateTimeQueries', date)
    }

    const steps = [
      { type: 'FullYear', label: '1Y', value: 1 },
      { type: 'Month', label: '1M', value: 1 },
      { type: 'Date', label: '1W', value: 7 },
      { type: 'Date', label: '1D', value: 1 },
      { type: 'Hours', label: '1H', value: 1 },
    ]

    function stepDate(step, direction) {
      const steppedDate = new Date(startDate.value.getTime())
      steppedDate[`set${step.type}`](
        direction === '-' ? steppedDate[`get${step.type}`]() - step.value : steppedDate[`get${step.type}`]() + step.value
      )
      setStartDate(steppedDate)
    }

    onMounted(() => {
      if (hasActiveMapInstance.value && maxEndDate.value) {
        setStartDate(maxEndDate.value)
      }
    })

    return {
      steps,
      stepDate,
      startDate,
      setStartDate,
      updateQueries,
    }
  },
}
</script>
